export const useGetCurrentFabricShowTabs = ({ product }: { product: any }) => {
  // 第一个 tab 的 fabric 选项`
  const fabricAmpProOptions = product?.ampProtOption?.items
    ?.find((item: any) => {
      return item?.label === 'Fabric';
    })
    ?.values?.map((value: any) => {
      return value?.label;
    }) as string[];

  // 第二个 tab 的 fabric 选项
  const availableProductFabricOption = product?.available_product?.configurable_options?.find((item: any) => {
    return item?.label === 'Fabric';
  });
  const availableProductAttributeCode = availableProductFabricOption?.attribute_code;
  const available_product_fabric_configurable_options = availableProductFabricOption?.values?.map((value: any) => {
    return {
      label: value?.label,
      valueIndex: value.value_index,
    };
  }) as { label: string; valueIndex: number }[];

  const availableProductFabricStockMap =
    product?.available_product?.variants?.reduce((acc, cur) => {
      if (cur?.product?.stock_status === 'IN_STOCK') {
        const fabricValueIndex = cur?.attributes?.find(x => x?.code === availableProductAttributeCode)?.value_index;

        if (fabricValueIndex) acc[fabricValueIndex] = 1;
      }

      return acc;
    }, {}) || {};

  // 选择哪些 fabric 的时候显示 tab
  const currentFabricArrayShowTabs: string[] | undefined =
    fabricAmpProOptions?.filter((item: any) => {
      if (
        !Array.isArray(available_product_fabric_configurable_options) ||
        available_product_fabric_configurable_options.length === 0
      ) {
        return true;
      }

      return available_product_fabric_configurable_options?.some(
        x => x.label === item.replace('-default', '') && availableProductFabricStockMap[x.valueIndex] === 1,
      );
    });

  const buttonThatDoNotExistFabricArray = fabricAmpProOptions?.filter((item: any) => {
    if (
      !Array.isArray(available_product_fabric_configurable_options) ||
      available_product_fabric_configurable_options.length === 0
    ) {
      return false;
    }

    return available_product_fabric_configurable_options.every(
      option =>
        !option.label.includes(item.replace('-default', '')) || !availableProductFabricStockMap[option.valueIndex],
    );
  });

  return {
    currentFabricArrayShowTabs,
    buttonThatDoNotExistFabricArray: buttonThatDoNotExistFabricArray,
  };
};
